module.exports = __webpack_public_path__ + "img/exercise_paused.a0a72acc.png";